import { inject, injectable, injectFromBase } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type PreloadRepository from '@/data/repositories/preloadRepository'
import StrictPreloaderService from '@/services/preloaders/strictPreloaderService'
import type UserNumbersService from '@/services/domain/user/userNumbersService'

@injectable()
@injectFromBase()
export default class UserNumbersPreloaderService extends StrictPreloaderService {
  constructor(
    @inject(SERVICE_TYPES.UserNumbersService) protected readonly userNumbersService: UserNumbersService,
    @inject(SERVICE_TYPES.PreloadRepository) protected readonly preloadRepository: PreloadRepository,
  ) {
    super(preloadRepository)
  }

  protected key = 'userNumbersPreloaderService'

  public async loadData(): Promise<void> {
    await this.userNumbersService.fetchUserNumbers()
  }
}
